/**
 * @param { number } date
 * Removes the time from a date
 */
function getDateStamp(date) {
  return new Date(date).setHours(0, 0, 0, 0);
}

export default getDateStamp;
